
import Vue from 'vue'
import { GridPlugin } from '@syncfusion/ej2-vue-grids'
import { ChartPlugin } from '@syncfusion/ej2-vue-charts'

Vue.use(GridPlugin)
Vue.use(ChartPlugin)
